import { useParams } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { colors } from '@factorialco/deprecated-design-system'
import { DocumentsPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import FilesCategoryList from 'modules/bookkeepers/components/PayrollCycle/FilesCategoryList'

const Documents = () => {
  const { company } = useCurrentSession()
  const { id } = useParams()
  const payrollRunId = Number(id)

  const { loading, data } = useQuery(DocumentsPageDocument, {
    variables: {
      companyId: company.id,
      payrollRunId: payrollRunId,
    },
  })

  const sharedCategories =
    data?.compensations?.fileCategoriesConnection?.nodes.filter(
      (category) => category.categoryType !== 'exported'
    ) ?? []
  const exportedCategories =
    data?.compensations?.fileCategoriesConnection?.nodes.filter(
      (category) => category.categoryType === 'exported'
    ) ?? []
  const sharedFilesCounter = sharedCategories.reduce(
    (acc, category) => acc + (category.filesConnection.totalCount ?? 0),
    0
  )

  if (loading) return <Loading />

  if (!data?.compensations?._policies?.compensationActivityManage?.can) {
    return <NotFound />
  }

  return (
    <>
      <Box padding="s24" gap="s8">
        <Text.Normal color="grey1000" weight="semibold">
          {i18n.t('bookkeepers.clients.payroll_cycles.documents.shared.title')}
        </Text.Normal>
        <Text size="200" color="grey700">
          {i18n.t('bookkeepers.clients.payroll_cycles.documents.shared.description')}
        </Text>
        <Box alignItems="center">
          {sharedFilesCounter === 0 && sharedCategories[0] ? (
            <FilesCategoryList key={sharedCategories[0].id} category={sharedCategories[0]} />
          ) : (
            sharedCategories.map(
              (category) =>
                (category.filesConnection.totalCount ?? 0) > 0 && (
                  <FilesCategoryList key={category.id} category={category} />
                )
            )
          )}
        </Box>
      </Box>
      <Box padding="s24" gap="s8" style={{ borderTop: `1px dashed ${colors.grey300}` }}>
        <Text.Normal color="grey1000" weight="semibold">
          {i18n.t('bookkeepers.clients.payroll_cycles.documents.internal.title')}
        </Text.Normal>
        <Text size="200" color="grey700">
          {i18n.t('bookkeepers.clients.payroll_cycles.documents.internal.description')}
        </Text>
        <Box alignItems="center">
          {exportedCategories.map((category) => (
            <FilesCategoryList key={category.id} category={category} />
          ))}
        </Box>
      </Box>
    </>
  )
}

export default Documents
